import { Factory } from 'rosie';

Factory.define('GuidePerformance');

Factory.define('GuidePerformanceWithDefaults')
  .extend('GuidePerformance')
  .attr('id', 'example-guide-id')
  .attr('name', 'Example Guide Name')
  .attr('type', 'TRANSACTION_GUIDE')
  .attr('collectionId', 'example-guide-collection-id')
  .attr('collectionName', 'Example Guide Collection Name')
  .attr('references', 150)
  .attr('handoffs', 43)
  .attr('resolved', 107)
  .attr('resolutionRate', 71.3);
